export default "__VITE_PUBLIC_ASSET__bf5ed59b__"